import { useState } from 'react';
import { api } from '../api';
import { Button, Field, Switch } from '../components/ui';

export function AuthPage({ setUp, setupCodeRequired, onDone }: { setUp: boolean; setupCodeRequired?: boolean; onDone: () => void }) {
  const [password, setPassword] = useState('');
  const [setupCode, setSetupCode] = useState('');
  const [confirm, setConfirm] = useState('');
  const [examples, setExamples] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!setUp && password !== confirm) return setError("Passwords don't match");
    setBusy(true);
    try {
      if (setUp) await api.post('/auth/login', { password });
      else await api.post('/auth/setup', { password, timezone: tz, examples, setupCode: setupCode || undefined });
      onDone();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <form className="card stack" onSubmit={submit}>
        <img className="logo" src="/icons/icon.svg" alt="" />
        <div>
          <h1>{setUp ? 'Welcome back' : 'Set up Tempo'}</h1>
          <p className="subtle small" style={{ marginTop: 6 }}>
            {setUp
              ? 'Sign in to see your plan.'
              : 'Your smart calendar: shifts, lectures, routines, study and travel – planned automatically. Pick a password to protect it (you can sign in on your phone, PC and laptop with it).'}
          </p>
        </div>
        <Field label="Password">
          <input className="input" type="password" autoFocus autoComplete={setUp ? 'current-password' : 'new-password'} value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        {!setUp && (
          <>
            {setupCodeRequired && (
              <Field label="Setup code" hint="The code you were given with this address (or TEMPO_SETUP_CODE, if you deployed it)">
                <input className="input" autoComplete="off" value={setupCode} onChange={(e) => setSetupCode(e.target.value)} />
              </Field>
            )}
            <Field label="Confirm password" hint="At least 8 characters">
              <input className="input" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </Field>
            <Switch on={examples} onChange={setExamples} label="Start with example routines" hint="Breakfast, gym, lunch, dinner, lecture notes, wind-down – edit or delete any time" />
            <p className="tiny faint">Timezone: {tz}</p>
          </>
        )}
        {error && <div className="callout danger small">{error}</div>}
        <Button type="submit" variant="primary" block loading={busy} disabled={!password || (!setUp && password.length < 8)}>
          {setUp ? 'Sign in' : 'Create my calendar'}
        </Button>
      </form>
    </div>
  );
}
